import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useTeacherToolsGet = (params) => {
  const { selectedTool, content, assumedLevel, skip } = params;
  const resource = `${API_BASE_URL}/api/v3/content/${content?.id}/${selectedTool}/?level_id=${assumedLevel?.id}`;

  return useRestQuery(resource, {
    skip: !selectedTool || !content || !assumedLevel || skip,
  });
};

export default useTeacherToolsGet;
